import * as stylex from '@stylexjs/stylex';
import { styles } from '../../styles';
import blocked from '../../assets/blocked.webp';

export const BlockedInvite = () => {
  return (
    <div {...stylex.props(styles.content)}>
      <img src={blocked} alt="Приглашение отклонено" {...stylex.props(styles.statusIllustration)} />
      <div {...stylex.props(styles.titleContent)}>
        <p {...stylex.props(styles.titleInfo)}>Приглашение недействительно</p>
      </div>
      <p {...stylex.props(styles.subTitleInfo)}>Приглашение было отозвано организатором</p>
    </div>
  );
};
